/* import { authHeader } from "../helpers/authHeader"; */
import { handleResponse } from "../../../../helpers/handleresponse";
import { authHeader } from "../../../../helpers/authHeader";

export const elementService = {
  getAll,
  update,
  create
};

async function getAll(eventId) {
  const requestOptions = {
    method: "GET" ,
    headers: authHeader({})
  };

  return fetch(`./api/formElement/${eventId}`, requestOptions)
    .then(handleResponse)
    .then(elements => {
      return elements;
    });
}


async function update(element) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(element)
  };

  return fetch(`./api/formElement`, requestOptions)
    .then(handleResponse)
    .then(element => {
      return element;
    });
}

async function create(element) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(element)
  };

  return fetch(`./api/formElement`, requestOptions)
    .then(handleResponse)
    .then(element => {
      return element;
    });
}
